import axios from 'axios'
import router from '../../../../router'
import submit from '../../../../router/submit'

export const indexDiscussions = ({ commit }, payload) => {
  return new Promise((resolve) => {
    axios.get('/api/discussions', {
      params: payload.params
    })
      .then(response => {
        commit('processDiscussions', response.data)
        resolve(response)
      })
      .catch(error => {
        if (error.response.status === 401) {
          commit('auth', null)
          router.push({ name: 'Login' })
        }
      })
  })
}

export const indexComments = ({ commit, state }, payload) => {
  return new Promise((resolve) => {
    const count = state.localDiscussions[payload.id] ? state.localDiscussions[payload.id].comments.length : 0
    axios.get('/api/discussions/' + payload.id + '/comments', {
      params: { count: count }
    })
      .then(response => {
        commit('processComments', { discussion: payload, comments: response.data.data })
        resolve(response)
      })
  })
}

export const freshComments = ({ commit, state }, payload) => {
  return new Promise((resolve) => {
    const count = 0
    axios.get('/api/discussions/' + payload.id + '/comments', {
      params: { count: count }
    })
      .then(response => {
        commit('clearDiscussion', payload.id)
        commit('processComments', { discussion: payload, comments: response.data.data })
        resolve(response)
      })
  })
}

export const submitComment = ({ commit, state }, payload) => {
  commit('submitting', true)
  return new Promise((resolve) => {
    submit.post('/api/discussions/' + payload.id + '/comments', payload)
      .then(response => {
        commit('processComments', { discussion: payload, comments: response.data.data })
        commit('submitting', false)
        resolve(response)
      })
  })
}

export const destroyComment = ({ commit, state }, payload) => {
  commit('submitting', true)
  return new Promise((resolve) => {
    axios.delete('/api/comments/' + payload.id)
      .then(response => {
        commit('submitting', false)
        commit('destroyComment', { id: payload.id, discussion: payload.discussion })
        resolve(response)
      })
  })
}
